import { Box, Drawer, ModalClose, Sheet, Typography, Divider } from "@mui/joy";
import { ReactNode } from "react";

interface MobileDrawerProps {
    open: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    height?: string | number;
}

export default function MobileDrawer({ open, onClose, title, children, height = "85dvh" }: MobileDrawerProps) {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            sx={{
                [`& .MuiDrawer-content`]: {
                    height,
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                    bgcolor: "background.surface",
                    boxShadow: "0 -10px 40px -10px rgba(0,0,0,0.3)",
                },
            }}
        >
            <Sheet
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    overflow: "hidden",
                    bgcolor: "background.surface",
                    pt: 2,
                }}
            >
                {/* <Box sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
                    <Box
                        sx={{
                            width: 100,
                            height: 4,
                            borderRadius: 2,
                            bgcolor: "neutral.outlinedBorder",
                            opacity: 0.5,
                        }}
                    />
                </Box> */}
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, px: 2 }}>
                    <Typography level="title-lg" sx={{ fontWeight: 700 }}>
                        {title}
                    </Typography>
                    <Box>
                        <ModalClose
                            variant="soft"
                            sx={{
                                borderRadius: "4px",
                                border: "1px solid",
                                borderColor: "divider",
                                position: "relative",
                                margin: 0,
                                top: 0,
                                bottom: 0,
                                right: 0,
                            }}
                        />
                    </Box>
                </Box>
                <Divider sx={{ mx: -2 }} />
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                        mt: 1,
                    }}
                >
                    {children}
                </Box>
            </Sheet>
        </Drawer>
    );
}
